import { render, staticRenderFns } from "./SmartCollection.vue?vue&type=template&id=5abb837c&"
import script from "./SmartCollection.vue?vue&type=script&lang=js&"
export * from "./SmartCollection.vue?vue&type=script&lang=js&"
import style0 from "./SmartCollection.vue?vue&type=style&index=0&id=5abb837c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SpotlightCarousel: require('/app/appsumo/nuxt/components/common/SpotlightCarousel.vue').default,ProductCarousel: require('/app/appsumo/nuxt/components/common/ProductCarousel.vue').default,TopPick: require('/app/appsumo/nuxt/components/common/TopPick.vue').default,Countdown: require('/app/appsumo/nuxt/components/common/Countdown.vue').default,BlackFridayRoadblock: require('/app/appsumo/nuxt/components/roadblocks/BlackFridayRoadblock.vue').default,EmailCaptureRoadblock: require('/app/appsumo/nuxt/components/roadblocks/EmailCaptureRoadblock.vue').default,BlackFridayEmailRoadblock: require('/app/appsumo/nuxt/components/roadblocks/BlackFridayEmailRoadblock.vue').default,EmailCaptureRoadblock: require('/app/appsumo/nuxt/components/roadblocks/EmailCaptureRoadblock.vue').default,NewPlusPromoRoadblock: require('/app/appsumo/nuxt/components/roadblocks/NewPlusPromoRoadblock.vue').default,ExploreRoadblock: require('/app/appsumo/nuxt/components/roadblocks/ExploreRoadblock.vue').default})
